export default function getHospitalsQueryObject(queryObj) {
  const BANGKOK_RELATED_SLUGS = [
    'bangkok-cancer',
    'bangkok-heart',
    'bangkok-bone-brain',
  ]

  const excludePostTypes = [
    'about_us',
    'plan_your_visit',
    'room_rate',
    'custom_page',
  ]

  const validHospitalSlugs = queryObj?.hospital_slugs?.filter(Boolean) || []
  const hasAllBangkoks =
    validHospitalSlugs.includes('bangkok') &&
    !excludePostTypes.includes(queryObj?.post_type) &&
    !queryObj.sitemap

  return {
    ...queryObj,
    hospital_slugs: hasAllBangkoks
      ? [...validHospitalSlugs, ...BANGKOK_RELATED_SLUGS]
      : validHospitalSlugs,
  }
}
